export default {
  '校园风采':'校园风采',
  '分类':'分类',
  '是否启用':'是否启用',
  '内容列表':'内容列表',
  '编辑名称':'编辑名称',
  '确认要开启{title}吗？':'确认要开启{title}吗？',
  '确认要关闭{title}吗？':'确认要关闭{title}吗？',
  '确认要停用吗？':'确认要停用吗？',
  '确认要删除吗？':'确认要删除吗？',
  '内容':'内容',
  '标题':'标题',
  '支持jpg/jpeg/png格式，建议比例为1:1，最大不超过5M':'支持jpg/jpeg/png格式，建议比例为1:1，最大不超过5M',
}
